import { buttonDefaults } from './button';

export const cardDefaults = {
  VBtn: buttonDefaults,
};
